<groundworks-modal>
  <groundworks-modal-header [title]="title()" [isCancellable]="true" (cancelModal)="cancel()" />
  <groundworks-modal-body>
    <form [formGroup]="form" (ngSubmit)="submit()">
      <div class="mb-2">
        @if (isEdit()) {
          <label for="commission-sales-rep-readonly">Sales Rep</label>
          <input
            id="commission-sales-rep-readonly"
            data-testid="commission-sales-rep-readonly"
            type="text"
            class="form-control"
            [value]="sellerName() ?? commission()?.userId ?? ''"
            readonly
          />
        } @else {
          <label for="commission-sales-rep">Sales Rep</label>
          <select
            id="commission-sales-rep"
            class="form-select"
            formControlName="userId"
            data-testid="commission-sales-rep-select"
          >
            <option value="" disabled>Select a sales rep</option>
            @for (person of salespeople(); track person.userId) {
              <option [value]="person.userId">{{ person.name ?? person.userId }}</option>
            }
          </select>
          @if (salespeopleError()) {
            <p class="text-danger" data-testid="sales-rep-load-error">{{ salespeopleError() }}</p>
          }
        }
        @if (isSelfGen()) {
          <div class="alert alert-warning mt-2 mb-0" data-testid="self-gen-message">
            Sales Rep is credited with a self-gen. Add 2% commission.
          </div>
        }
      </div>
      <div class="row mb-2">
        <div class="col">
          <label for="commission-percent">% of Commission</label>
          <div class="input-group">
            <input
              id="commission-percent"
              type="number"
              step="0.01"
              class="form-control text-end"
              formControlName="percent"
              data-testid="commission-percent"
            />
            <span class="input-group-text">%</span>
          </div>
        </div>
        <div class="col">
          <label for="commission-amount">Commission Amount</label>
          <div class="input-group">
            <span class="input-group-text">$</span>
            <input
              id="commission-amount"
              type="number"
              step="0.01"
              class="form-control text-end"
              formControlName="amount"
              data-testid="commission-amount"
            />
          </div>
        </div>
      </div>
      @if (errorMessage()) {
        <p class="text-danger">{{ errorMessage() }}</p>
      }
    </form>
  </groundworks-modal-body>
  <groundworks-modal-footer [actions]="footerActions()" />
</groundworks-modal>
